import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditIcon from "@mui/icons-material/Edit";
import {
  Container,
  Grid,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import CustomButton from "../../../components/CustomButton";
import CustomModal from "../../../components/CustomModal/CustomModal";
import {
  deleteProcedureById,
  getProceduresByPetId,
} from "../../../redux/reducers/petSlice";
import { AppColors } from "../../../util/AppColors";
import { tblGrayBack } from "../../../util/object";
import { canWriteModule } from "../../../util/roleModuleAccess";
import CreateUpdateReminder from "./CreateUpdateReminder";

const tblHdrs = [
  "procedureName",
  "category",
  "subCategory",
  "doneAt",
  "remarks",
  "status",
  "extraStatus",
];
const nameExpan = {
  procedureName: "Procedure Name",
  category: "Category",
  subCategory: "Subcategory",
  remarks: "Remarks",
  status: "Status",
  extraStatus: "",
  doneAt: "Date",
  nextDueDate: "Next Due Date",
};

const delBtn = { color: AppColors.red, width: 20, height: 20 };
const edtBtn = { color: AppColors.appPrimary, width: 20, height: 20 };

const ReminderPreventive = ({ addVsble, setAddVsble }) => {
  const dispatch = useDispatch();
  const canManageDashboard = canWriteModule("dashboard");
  const location = useLocation();
  const { appointment } = location.state;
  const [modVsble, setModVsble] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [delModVsble, setDelModVsble] = useState(false);
  const [page, setPage] = useState(1);
  const procedure = useSelector((state) => state?.pet?.procedure);
  const {
    services,
    clinicStocks,
    details: clinicDet,
  } = useSelector((state) => state?.clinic);
  const apntDet = useSelector((state) => state?.pet?.complaintSummary?.data);
  const appDet = apntDet?.appointment;
  const itemSize = 10;

  useEffect(() => {
    getProcedures();
  }, []);

  useEffect(() => {
    if (addVsble) setModVsble(addVsble);
  }, [addVsble]);

  const getProcedures = (pge = 1) => {
    setPage(pge);
    dispatch(
      getProceduresByPetId({
        petId: appointment?.appoinment?.petId,
        url: `?reminderPreventive=true&page=${pge}&itemSize=${itemSize}`,
      }),
    );
  };

  const handleModClose = () => {
    setAddVsble(false);
    setModVsble(false);
    setSelectedItem(null);
  };

  const handleDelete = (itm) => {
    setSelectedItem(itm);
    setDelModVsble(true);
  };

  const handleSuccess = () => {
    getProcedures();
    handleModClose();
  };

  const onCloseMod = (typ) => {
    if (typ === "apiSuccess") getProcedures();
    handleModClose();
  };

  const getBatch = (stockId, batchId = null, retStock = false) => {
    if (!stockId) return null;
    const reqStock = clinicStocks?.data?.find(
      (stc) => stc?.stockId === stockId,
    );
    if (retStock) return reqStock;
    if (!batchId) return null;
    return (
      reqStock?.stockBatch?.find((bat) => bat?.batchId === batchId) ?? null
    );
  };

  const onCloseDelMod = () => {
    setDelModVsble(false);
    setSelectedItem(null);
  };

  const onConfirmDelete = () => {
    if (!selectedItem?.procedureId) return;
    dispatch(deleteProcedureById(selectedItem?.procedureId)).then((res) => {
      if (res?.payload) {
        getProcedures();
        onCloseDelMod();
      }
    });
  };

  const handleChangePage = (e, selectedPage) => {
    getProcedures(selectedPage);
  };

  const handleEdit = (det) => {
    setSelectedItem(det);
    setModVsble(true);
  };

  const getProcedureList = () => {
    return procedure?.data?.filter(
      (li) => !li?.appointmentId && li?.isFromPreventive,
    );
  };

  return (
    <>
      <Container maxWidth="xl">
        <div className="back-white">
          <TableContainer sx={{ maxHeight: 400 }} className="mv20">
            <Table
              sx={{ minWidth: 200 }}
              aria-labelledby="tableTitle"
              stickyHeader
            >
              <TableHead>
                <TableRow>
                  {tblHdrs?.map((hdr, i) => (
                    <TableCell
                      style={tblGrayBack}
                      className="table-header-text"
                      key={hdr + i}
                    >
                      {nameExpan?.[hdr]}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              {getProcedureList()?.length === 0 && (
                <TableRow>
                  <TableCell colSpan={12} className="text-align-center h100">
                    <div className="no-rec">No records available</div>
                  </TableCell>
                </TableRow>
              )}
              <TableBody>
                {getProcedureList()?.map((li, ind) => {
                  return (
                    <TableRow>
                      {tblHdrs?.map((hdr, i) => {
                        return (
                          <TableCell key={`${ind} + ${i} + tr`} component="th">
                            <div>
                              {
                                // hdr === "procedureName" ? (
                                //   <div>
                                //     <Custom3dotString
                                //       str={li?.[hdr]}
                                //       className="blue-color txt-semi-bold fs14 cursor"
                                //       length={12}
                                //     />
                                //   </div>
                                // ) :
                                hdr === "status" ? (
                                  <div>
                                    <Typography
                                      className={`ph10 pv5 br5 flex-center font-medium fs14 ${
                                        new Date(li?.doneAt) >
                                        new Date(
                                          new Date().setHours(0, 0, 0, 0),
                                        )
                                          ? "pending"
                                          : "overdue"
                                      }`}
                                    >
                                      {new Date(li?.doneAt) >
                                      new Date(new Date().setHours(0, 0, 0, 0))
                                        ? "Pending"
                                        : "Overdue"}
                                    </Typography>
                                  </div>
                                ) : hdr === "extraStatus" ? (
                                  <div className="flex1-end">
                                    {canManageDashboard ? (
                                      <>
                                        <div
                                          className="cursor"
                                          onClick={() => handleEdit(li)}
                                        >
                                          <div className="flex-center">
                                            <EditIcon sx={edtBtn} />
                                          </div>
                                          <Typography className="blue-color fs8 txt-semi-bold text-align-center">
                                            Edit
                                          </Typography>
                                        </div>
                                        <div
                                          className="cursor ml15"
                                          onClick={() => handleDelete(li)}
                                        >
                                          <div className="flex-center">
                                            <DeleteOutlineIcon sx={delBtn} />
                                          </div>
                                          <Typography className="red3 fs8 txt-semi-bold text-align-center">
                                            Delete
                                          </Typography>
                                        </div>
                                      </>
                                    ) : null}
                                  </div>
                                ) : hdr === "doneAt" ? (
                                  moment(new Date(li?.[hdr])).format(
                                    "DD MMM YYYY",
                                  )
                                ) : (
                                  li?.[hdr]
                                )
                              }
                            </div>
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
              </TableBody>
              {Math.ceil(procedure?.totalRecords / itemSize) > 1 ? (
                <TableFooter>
                  <TableRow>
                    <TableCell colSpan={12}>
                      <div className="flex-end">
                        <Pagination
                          count={Math.ceil(procedure?.totalRecords / itemSize)}
                          variant="outlined"
                          color="primary"
                          page={page}
                          onChange={handleChangePage}
                        />
                      </div>
                    </TableCell>
                  </TableRow>
                </TableFooter>
              ) : null}
            </Table>
          </TableContainer>
        </div>
      </Container>

      {modVsble ? (
        <CreateUpdateReminder
          modVsble={modVsble}
          onCloseMod={onCloseMod}
          selectedItem={selectedItem}
          selecetdtype="Preventive"
          addToAppointment={false}
        />
      ) : null}

      <CustomModal
        open={delModVsble}
        onClose={onCloseDelMod}
        header="Delete"
        modal
        modalWidth={40}
      >
        <Typography className="txt-regular fs16 ml10">
          Are you sure you want to delete the procedure?
        </Typography>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <div className="flex-center mb10 mt15">
            <div className="mr10">
              <CustomButton
                text="Yes"
                redBtn
                smallBtn
                onClick={onConfirmDelete}
              />
            </div>
            <div className="ml10">
              <CustomButton
                text="No"
                onClick={() => setDelModVsble(false)}
                smallBtn
              />
            </div>
          </div>
        </Grid>
      </CustomModal>
    </>
  );
};

export default ReminderPreventive;
